export const HpIcon = () => {
  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.5 45C22.2917 45 22.0486 45 21.8403 45L26.4236 32.3611H32.7431C33.8542 32.3611 35.0694 31.4931 35.4514 30.4514L40.4514 16.7361C41.2847 14.4792 39.9653 12.6389 37.6042 12.6389H28.8194L21.4583 32.9167L17.2917 44.4097C7.39583 42.0486 0 33.1597 0 22.5C0 12.1875 6.94444 3.47222 16.4236 0.833332L12.1181 12.6736L4.96528 32.3611H9.72222L15.7986 15.625H19.375L13.2986 32.3611H18.0556L23.75 16.7708C24.5833 14.5139 23.2986 12.6736 20.9028 12.6736H16.875L21.4931 0.0347217C21.8403 0.0347217 22.1528 0 22.5 0C34.9306 0 45 10.0694 45 22.5C45 34.9306 34.9306 45 22.5 45ZM36.1111 15.625H32.5347L27.5 29.4097H31.0764L36.1111 15.625Z"
        fill="#F4F4F4"
      />
    </svg>
  )
}
